import { Injectable, Optional } from '@angular/core';
import { AbstractApiController } from './abstract-api-controller';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../configuration';
import { MonthlyDeliveryIncomeResponse } from '../model/response/monthly-delivery-income.response';
import { MonthlyIncomeRequest } from '../model/request/monthly-income.request';
import { MonthlyDeliveryIncomeDetailResponse } from '../model/response/monthly-delivery-income-detail.response';

@Injectable()
export class AdminMonthlyBillingApi extends AbstractApiController {

  constructor(
    private http: HttpClient,
    @Optional() config?: Configuration
  ) {
    super();
    this.baseUrl = (config && config.apiBaseUrl)
      ? config.apiBaseUrl : 'https://example.com';
  }

  public fetchIncomes(page, limit, filter = null) {
    return this.http.get<MonthlyDeliveryIncomeResponse>(
      this.prepareListRequest(
        this.baseUrl + '/api/cf/administration/monthly-billing',
        page,
        limit,
        [{deliveryIncomes: 'DESC'}],
        filter
      ),
      {headers: this.getAuthHeaders()}
    );
  }

  public fetchById(id) {
    return this.http.get<MonthlyDeliveryIncomeDetailResponse>(
      this.baseUrl + '/api/cf/administration/monthly-billing/' + id,
      {headers: this.getAuthHeaders()}
    );
  }

  public pairRegistration(request: MonthlyIncomeRequest) {
    return this.http.post<any>(
      this.baseUrl + '/api/cf/administration/monthly-billing/pair-registration'
      , request
      , {headers: this.getAuthHeaders()}
    );
  }
}
